import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class ModalStatusBar extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      message: props.message,
    };
  }

  setMessage(message) {
    this.setState({ message });
  }

  render() {
    return (
      <div className="statusbar-wrapper">
        <div className="details">{this.state.message}</div>
      </div>
    );
  }
}

ModalStatusBar.defaultProps = {
  message: 'Ready',
};

ModalStatusBar.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ModalStatusBar;
